import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'directories.filters-v2.main.flags.delete.error.title',
		defaultMessage: "We couldn't delete {name}",
		description:
			'Title of the flag shown in Filters Directory when the request for deleting a filter failed',
	},
	description: {
		id: 'directories.filters-v2.main.flags.delete.error.description',
		defaultMessage: 'There was an error, please try again.',
		description:
			'Message shown in the flag displayed in Filters Directory when the request for deleting a filter failed',
	},
});

const deleteError = ({ name }: { name: string }): FlagConfiguration => ({
	type: 'error',
	title: [messages.title, { name }],
	description: messages.description,
	messageId: 'filters-main.flags.delete.flag.error',
	messageType: 'transactional',
});

export default deleteError;
